import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Validators from './validators'
import { BaseManipStateFn, BaseTableState } from './base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    prepareNew () { }

    onSaved (saved) {
      super.onSaved(saved)
    }

    requiredOptions = [
      'Countries'
    ]

    createtitle = store.__(linkConst.LINK_RATING_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_RATING_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)

    validators = {
      regions: Validators.regionTest(store),
      regions_default: Validators.regionTest(store),
      minimum_age: Validators.positiveInt(store)
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id',
      'name',
      'description',
      'minimum_age',
      'parent_guidance',
      'regions',
      'regions_default'
    ]

    headertitles = [
      store.__('ID'),
      store.__('name'),
      store.__('description'),
      store.__('minimum age'),
      store.__('parent guidance'),
      store.__('regions'),
      store.__('default in regions')
    ]

    title = store.__(linkConst.LINK_RATING_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_RATING]

    requiredOptions = [
      'Countries'
    ]

    init () {
      return super.init()
    }
  }

  return { ManipState, TableState }
}
